<div layout="row" layout-align="space-between center" class="input-container" flex>
  @for (input of inputs.controls; track input; let i = $index) {
    <input
      class="totp-field"
      #inputEl
      (focus)="handleFocus($event)"
      (blur)="onTouched?.()"
      (keypress)="handleKeyPress($event, i)"
      (input)="handleInput()"
      (keydown)="handleKeyDown($event, i)"
      (keyup.enter)="submitForm()"
      (paste)="handlePaste($event, i)"
      [formControl]="$any(input)"
      [attr.autocomplete]="i === 0 ? 'one-time-code' : null"
      type="text"
      inputmode="numeric"
      [ngClass]="{ 'colorized': input?.value !== '' }"
      />
  }
</div>